export var LoadableEntryAction;
(function (LoadableEntryAction) {
    LoadableEntryAction[LoadableEntryAction["NoOp"] = 0] = "NoOp";
    LoadableEntryAction[LoadableEntryAction["New"] = 1] = "New";
    LoadableEntryAction[LoadableEntryAction["Resume"] = 2] = "Resume";
})(LoadableEntryAction || (LoadableEntryAction = {}));
export var UnloadableEntryAction;
(function (UnloadableEntryAction) {
    UnloadableEntryAction[UnloadableEntryAction["NoOp"] = 0] = "NoOp";
    UnloadableEntryAction[UnloadableEntryAction["Destroy"] = 1] = "Destroy";
    UnloadableEntryAction[UnloadableEntryAction["Pause"] = 2] = "Pause";
})(UnloadableEntryAction || (UnloadableEntryAction = {}));
export var NavigationType;
(function (NavigationType) {
    NavigationType[NavigationType["GoForwardNewState"] = 0] = "GoForwardNewState";
    NavigationType[NavigationType["GoForwardResumeState"] = 1] = "GoForwardResumeState";
    NavigationType[NavigationType["GoBackward"] = 2] = "GoBackward";
    NavigationType[NavigationType["Replace"] = 3] = "Replace";
})(NavigationType || (NavigationType = {}));
export var StackRouterEventType;
(function (StackRouterEventType) {
    StackRouterEventType[StackRouterEventType["Navigate"] = 0] = "Navigate";
    StackRouterEventType[StackRouterEventType["Mount"] = 1] = "Mount";
    StackRouterEventType[StackRouterEventType["Destroy"] = 2] = "Destroy";
    StackRouterEventType[StackRouterEventType["UpdateConfig"] = 3] = "UpdateConfig";
})(StackRouterEventType || (StackRouterEventType = {}));
